import type { ChatSession } from "@racler/protocol";

export interface ChatGroup {
  label: "Today" | "Yesterday" | "Older";
  items: ChatSession[];
}

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();

/** Today / Yesterday / Older by local calendar day, newest first. Empty groups are omitted. */
export function groupChats(sessions: ChatSession[], now = new Date()): ChatGroup[] {
  const today = startOfDay(now);
  const yesterday = today - 86_400_000;
  const groups: ChatGroup[] = [
    { label: "Today", items: [] },
    { label: "Yesterday", items: [] },
    { label: "Older", items: [] },
  ];
  const sorted = [...sessions].sort((a, b) => Date.parse(b.updatedAt) - Date.parse(a.updatedAt));
  for (const s of sorted) {
    const day = startOfDay(new Date(s.updatedAt));
    groups[day >= today ? 0 : day >= yesterday ? 1 : 2]!.items.push(s);
  }
  return groups.filter((g) => g.items.length > 0);
}

/** Compact relative time for lists ("5m", "3h", "2d"; older dates as a short date). */
export function relativeTime(iso: string, now = new Date()): string {
  const diff = Math.max(0, now.getTime() - Date.parse(iso));
  const min = Math.floor(diff / 60_000);
  if (min < 1) return "now";
  if (min < 60) return `${min}m`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h}h`;
  const d = Math.floor(h / 24);
  if (d < 14) return `${d}d`;
  return new Date(iso).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}
